var data = [{
    // name: 'ROU',
    fullName: 'Rourkela',
    lat: 22.2604,
    lon: 84.8536,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black',
        // color: '#FFFFFF',
        // backgroundColor: "#1e81c6",
    },
}, {
    // name: 'AG',
    fullName: 'Agartala',
    lat: 23.8315,
    lon: 91.2868,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    },
}, {
    // name: 'Az',
    fullName: 'Aizawl',
    lat: 23.7271,
    lon: 92.7176,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
}, {
    // name: 'ITN',
    fullName: 'Itanagar',
    lat: 27.0869,
    lon: 93.6086,
    dataLabels: {
        align: 'right',
        y: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
}, {
    // name: 'SHL',
    fullName: 'Shillong',
    lat: 25.5788,
    lon: 91.8933,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
}, {
    // name: 'AJ',
    fullName: 'Ajmer',
    lat: 26.4499,
    lon: 74.6399,
    dataLabels: {
        align: 'left',
        x: 5,
        y: -8,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
}, {
    // name: 'BKR',
    fullName: 'Bikaner',
    lat: 28.0229,
    lon: 73.3119,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
}, {
    // name: 'JDH',
    fullName: 'Jodhpur',
    lat: 26.2389,
    lon: 73.0243,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
}, {
    // name: 'KT',
    fullName: 'Kota',
    lat: 25.2138,
    lon: 75.8648,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
}, 
{
    // name: 'UDP',
    fullName: 'Udaipur',
    lat: 24.5854,
    lon: 73.7125,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
}, 

{
    // name: 'UDP',
    fullName: 'Gwalior',
    lat: 26.2182,
    lon: 78.1828,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},





// {
//     // name: 'MG',
//     fullName: 'Meghalaya',
//     stations: ['Shillong'],
//     lat: 25.4670,
//     lon: 91.3662,
//     dataLabels: {
//         align: 'left',
//         x: 5,
//         verticalAlign: 'middle',
//         border: '1px solid black'
//     }
// }, 

{
    // name: 'AGR',
    fullName: 'Agra',
    lat: 27.1767,
    lon: 78.0081,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'ALG',
    fullName: 'Aligarh',
    lat: 27.8974,
    lon: 78.088,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'ALB',
    fullName: 'Allahabad',
    lat: 25.4358,
    lon: 81.8463,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'BRL',
    fullName: 'Bareilly',
    lat: 28.367,
    lon: 79.4304,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'JHS',
    fullName: 'Jhansi',
    lat: 25.4484,
    lon: 78.5685,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'KNP',
    fullName: 'Kanpur',
    lat: 26.4499,
    lon: 80.3319,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'LKN',
    fullName: 'Ranchi',
    lat: 23.3441,
    lon:  85.3096,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'GRP',
    fullName: 'Jamshedpur',
    lat: 22.8046,
    lon: 86.2029,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'VRS',
    fullName: 'Varanasi',
    lat: 25.3176,
    lon: 82.9739,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'SPR',
    fullName: 'Sholapur',
    lat: 17.6599,
    lon: 75.9064,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'NGP',
    fullName: 'Nagpur',
    lat: 21.1458,
    lon: 79.0882,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'AGD',
    fullName: 'Aurangabad',
    lat: 19.8762,
    lon: 75.3433,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'KHP',
    fullName: 'Kolhapur',
    lat: 16.705,
    lon: 74.2433,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'ADR',
    fullName: 'Ahmednagar',
    lat: 19.0952,
    lon: 74.7496,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'BRD',
    fullName: 'Baroda',
    lat: 22.3072,
    lon:73.1812,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'RJT',
    fullName: 'Rajkot',
    lat: 22.3039,
    lon: 70.8022,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'AGD',
    fullName: 'Aurangabad',
    lat: 19.8762,
    lon: 75.3433,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'SR',
    fullName: 'Surat',
    lat: 21.1702,
    lon: 72.8311,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'CH',
    fullName: 'Chandigarh',
    lat: 30.7333,
    lon: 76.7794,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'JLD',
    fullName: 'Jalandhar',
    lat: 31.326,
    lon: 75.5762,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'AMR',
    fullName: 'Amritsar',
    lat: 31.634,
    lon: 74.8723,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'PTL',
    fullName: 'Patiala',
    lat: 30.3398,
    lon: 76.3869,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'HSR',
    fullName: 'Hissar',
    lat: 29.1492,
    lon: 75.7217,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'ASN',
    fullName: 'Asansol',
    lat: 23.6889,
    lon: 86.9661,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'BHB',
    fullName: 'Bhubaneswar',
    lat: 20.2961,
    lon: 85.8245,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'MZP',
    fullName: 'Muzaffarpur',
    lat: 26.1209,
    lon: 85.3647,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'PTN',
    fullName: 'Patna',
    lat: 25.5941,
    lon: 85.1376,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'KNP',
    fullName: 'Kanpur',
    lat: 26.4499,
    lon: 80.3319,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'LKN',
    fullName: 'Lucknow',
    lat: 26.8467,
    lon: 80.9462,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'GRK',
    fullName: 'Gorakhpur',
    lat: 26.7347,
    lon: 83.3362,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'DLH',
    fullName: 'Delhi',
    lat: 28.7041,
    lon: 77.1025,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'MUB',
    fullName: 'Mumbai',
    lat: 19.076,
    lon: 72.8777,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'BGL',
    fullName: 'Bangalore',
    lat: 12.9716,
    lon: 77.5946,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'HDR',
    fullName: 'Hyderabad',
    lat: 17.385,
    lon: 78.4867,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'KOL',
    fullName: 'Kolkata',
    lat: 22.5726,
    lon: 88.3639,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'CHN',
    fullName: 'Chennai',
    lat: 13.0827,
    lon: 80.2707,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'PN',
    fullName: 'Pune',
    lat: 18.5204,
    lon: 73.8567,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
// {
//     // name: 'AHM',
//     fullName: 'Ahmedabad',
//     lat: 23.0225,
//     lon: 72.5714,
//     dataLabels: {
//         align: 'left',
//         x: 5,
//         verticalAlign: 'middle',
//         border: '1px solid black'
//     }
// },
{
    // name: 'POD',
    fullName: 'Pondicherry',
    lat: 11.9416,
    lon: 79.8083,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'MNG',
    fullName: 'Mangalore',
    lat: 12.9141,
    lon: 74.856,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'MYS',
    fullName: 'Mysore',
    lat: 12.2958,
    lon: 76.6394,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'TIR',
    fullName: 'Tirupati',
    lat: 13.6288,
    lon: 79.4192,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'TRI',
    fullName: 'Trivandrum',
    lat: 8.5241,
    lon: 76.9366,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'SRN',
    fullName: 'Srinagar',
    lat: 34.0836,
    lon: 74.7973,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'SHM',
    fullName: 'Shimla',
    lat: 31.1048,
    lon: 77.1734,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'TIR',
    fullName: 'Tirupati',
    lat: 13.6288,
    lon: 79.4192,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'PAN',
    fullName: 'Panaji',
    lat: 15.4909,
    lon:73.8278,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'BHP',
    fullName: 'Bhopal',
    lat: 23.2599,
    lon: 77.4126,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'JM',
    fullName: 'Jammu',
    lat: 32.7266,
    lon: 74.857,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'IND',
    fullName: 'Indore',
    lat: 22.7196,
    lon: 75.8577,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
},
{
    // name: 'GUW',
    fullName: 'Guwahati',
    lat: 26.1445,
    lon: 91.7362,
    dataLabels: {
        align: 'left',
        x: 5,
        verticalAlign: 'middle',
        border: '1px solid black'
    }
}



,]

export default data;


// WEBPACK FOOTER //
// ./web/util/mapCityData.js